import FormErrors from "@/components/FormErrors/FormErrors";
import { JSConn } from "@/utilities/js-conn";

const STATUS_INITIAL = 0,
  STATUS_SAVING = 1,
  STATUS_SUCCESS = 2,
  STATUS_FAILED = 3;

export default {
  name: "workOrderLotEditForm",
  props: {
    workOrderAttachmentId: String,
  },
  components: {
    FormErrors,
  },
  data() {
    return {
      file: "",
      hasAttachmentErrors: false,
      attachmentErrors: [],
      uploadError: null,
      currentStatus: null,
    };
  },
  computed: {
    isInitial() {
      return this.currentStatus === STATUS_INITIAL;
    },
    isSaving() {
      return this.currentStatus === STATUS_SAVING;
    },
    isSuccess() {
      return this.currentStatus === STATUS_SUCCESS;
    },
    isFailed() {
      return this.currentStatus === STATUS_FAILED;
    },
    workOrder() {
      return this.$store.getters.workOrder;
    },
  },
  methods: {
    handleFileUpload() {
      this.file = this.$refs.workOrderAttachments.files[0];
      this.currentStatus = STATUS_SAVING;
    },
    reset() {
      // reset form to initial state
      this.currentStatus = STATUS_INITIAL;
      this.uploadError = null;
    },
    submitAttachments(evt) {
      evt.preventDefault();
      let formData = new FormData();

      formData.append("attachment", this.file, this.file.name);
      formData.append("id", "new");
      formData.append("work_order_id", this.workOrder.id);

      const jsConn = new JSConn();

      jsConn.formParams = formData;

      this.$store.dispatch("createWorkOrderAttachment", jsConn).then(() => {
        // move to the list of attachments
        this.$router.push({
          name: "workOrderAttachments",
        });
        this.$emit("attachmentsChanged");
      });
    },
  },
  mounted() {
    this.reset();
  },
};
